module.exports = __webpack_public_path__ + "static/media/nodeJs.3952f26d.gif";